// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".TableUnitCell .unit-number {\n  display: block;\n  font-weight: bold;\n  font-size: 16px; }\n", ""]);
// Exports
module.exports = exports;
